<template>
 <div>

		<div class="white">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li v-if="roles['Admin'] || user.privileges.pages['settings/dashboard']"><router-link to="/settings/dashboard">Dashboard</router-link></li>
								<li v-if="roles['Admin'] || user.privileges.pages['settings/translations']"><router-link to="/settings/translations">Translations</router-link></li>
								<li v-if="roles['Admin'] || user.privileges.pages['settings/languages']"><router-link to="/settings/languages">Languages</router-link></li>
								<!-- <li><router-link to="/settings/mails">Mails (Triggers)</router-link></li> -->
								<!-- <li><router-link to="/settings/import">Import</router-link></li> -->
								<!-- <li><router-link to="/settings/views">Views</router-link></li> -->
								<li v-if="roles['Admin']"><router-link to="/settings/site-settings">Site settings</router-link></li>
								<li v-if="roles['Admin'] || user.privileges.pages['settings/caching']"><router-link to="/settings/caching">Caching</router-link></li>
								<li v-if="roles['Admin']"><router-link to="/settings/logs">Logs</router-link></li>
							</ul>
						</nav>
					</div>

				</div>
			</div>
		</div>

		<router-view></router-view>

	</div>
</template>

<script>

export default {
	name: 'GeneralSettings',

	data () {
		return {
			roles: this.$store.state.user.roles,
			user: this.$store.state.user
		}
	},

	updated () {
		this.roles = this.$store.state.user ? this.$store.state.user.roles : null
		this.user = this.$store.state.user
	}
}

</script>
